<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "v-im"
};
</script>
<style lang="scss">
html {
  font-size: 12px;
  background-color: transparent;
}

#app {
  position: relative;
}
</style>
